import React, { Component } from 'react';
import * as d3 from 'd3';
import './Dashboard.css';
import math from 'mathjs';

class Dial extends Component {
    constructor(props) {
        super(props);

        this.arcTween = this.arcTween.bind(this);
        this.updateDial = this.updateDial.bind(this);
        this.drawDial = this.drawDial.bind(this);

        this.arc = d3.arc()
            .innerRadius(this.props.width/2 - 30)
            .outerRadius(this.props.width/2)
            .startAngle(-Math.PI/2);

        this.scale = d3.scaleLinear().range([-Math.PI/2, Math.PI/2]).domain([0, 100]);
    }

    drawDial() {
        let bg = d3.arc()
            .innerRadius(this.props.width/2 - 15 - 3)
            .outerRadius(this.props.width/2 - 15 + 3)
            .startAngle(-Math.PI/2)
            .endAngle(Math.PI/2);

        d3.select(this.node)
            .append("g")
                .attr("transform", "translate(" + this.props.width/2 + "," + this.props.width/2 + ")")
            .append("path")
            .style("fill", "white")
            .attr("d", bg);

        d3.select(this.node)
            .append("g")
                .attr("transform", "translate(" + this.props.width/2 + "," + this.props.width/2 + ")")
                .attr("class", "dial")
            .append("path")
            .datum({endAngle: this.scale(this.props.value)})
            .style("fill", d3.interpolateViridis(this.props.value/110))
            .attr("d", this.arc);

        d3.select(this.node)
            .append("g")
                .attr("transform", "translate(" + this.props.width/2 + "," + this.props.width/2 + ")")
            .append("line")
                .attr("x1", 0)
                .attr("x2", 0)
                .attr("y1", -(this.props.width/2))
                .attr("y2", -(this.props.width/2 - 30))
                .style("stroke", "white")
                .style("stroke-width", 6);
    }

    arcTween(newAngle) {
        return (d) => {
            var interpolate = d3.interpolate(d.endAngle, newAngle);
  
            return (t) => {
                d.endAngle = interpolate(t);
                return this.arc(d);
            }
        }
    }

    updateDial() {
        d3.select(this.node)
            .select("g.dial").select("path")
            .transition().duration(1000).ease(d3.easeBounceOut)
            .attrTween("d", this.arcTween(this.scale(this.props.value)))
            .style("fill", d3.interpolateViridis(this.props.value/110));

        

        // d3.select(this.node)
        //     .select("g").select("path")
        //     .transition().duration(1000)
        //     .style("fill", d3.interpolateViridis(this.props.value/100));
    }

    componentDidMount() {
        this.drawDial();
    }

    componentDidUpdate() {
        this.updateDial();
    }

    render() {
        return <svg width={this.props.width} height={this.props.width/2} ref={(node) => {this.node = node;}}></svg>
    }
}

class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.node = React.createRef();
    }

    changed() {
        this.props.callback(this.node.current.value);
    }

    render() {
        return <select value={this.props.selected} style={{width: `${(8.2*this.props.values[this.props.selected].length) + 50}px`}} onChange={this.changed.bind(this)} ref={this.node}>
            {this.props.order.map((k) => {
                return <option key={k} value={k}>{this.props.values[k]}</option>
            })}
        </select>
    }
}

class Row extends Component {
    getAdjectives(v) {
        v = +v;
        if (v < -1) {
            return "much less likely";
        } else if (v < -0.5) {
            return "unlikely";
        } else if (v < 0) {
            return "slightly less likely";
        } else if (v === 0) {
            return "likely as average";
        } else if (v < 0.5) {
            return "slightly more likely";
        } else if (v < 1) {
            return "likely";
        } else {
            return "very likely";
        }
    }

    render() {
        let multiplier = 1;
        if (typeof(this.props.property.multiplier) !== "undefined") {
            multiplier = this.props.property.multiplier;
        }

        let v = 50 * (1 + math.erf((this.props.value * multiplier)/Math.sqrt(2)));

        let row = <div className={"dialtext" + (this.props.flip ? " flip" : "")}>
            {"I am " + 
            this.getAdjectives(this.props.value * multiplier) + " " + 
            this.props.property.intro + " " + 
            this.props.property.property + "."}
        </div>;

        // if (v == 50) {
        //     row = <div className={"dialtext" + (this.props.flip ? " flip" : "")}>
        //         {"Missing data for " + (this.props.property.missing ? this.props.property.missing : this.props.property.property)}
        //     </div>;
        //     v = 0;
        // }

        let after;
        let before;
        if (this.props.flip) {
            after = row;
        } else {
            before = row;
        }

        return (
            <React.Fragment>
            <div class="dialrow">
                {before}
                <Dial value={v} width={180}/>
                {after}
            </div>
            </React.Fragment>
        )
    }
}

const defaultFilters = {vancouver: ['99', '99', '99', '99', '99'],
    auckland: ['Total', 'Total Stated', 'Total', 'New Zealand born'],
    sydney: ['Persons', 'Total Persons 18-64', "Total persons (ANC1P)", "Total"]};

const keyOrder = {vancouver: ['Age', 'Immig_coh', 'Vis_min', 'Sex', 'Immig_cat'],
    auckland: ['Age', 'Ethnicity', 'Sex', 'Immigration'],
    sydney: ['Sex', 'Age', 'Ethnicity', 'ImmigGen']};

const whoOrder = {
    vancouver: {
        Immig_coh: [99, 1, 12, 2, 31, 33, 34, 35, 36],
        Vis_min: [99, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        Immig_cat: [99, 1, 2, 3],
        Age: [99, 1, 2, 3, 4, 5],
        Sex: [99, 1, 2]
    },
    auckland: {
        Age: ["Total", "18 Years - 24 Years", "25 Years - 34 Years", "35 Years - 44 Years", "45 Years - 54 Years", "55 Years - 64 Years", "65 Years and Over"],
        Ethnicity: ["Total Stated", "Total Asian", "Chinese", "Indian", "Southeast Asian",  "Asian nfd - Other Asian", "Middle Eastern", "Latin American", "European", "African", "Pacific Peoples", "Mäori", "Other Ethnicity"],
        Sex: ["Total", "Female", "Male"],
        Immigration: ["Total", "New Zealand born", "Immig. Pre1980", "Immig. 1980 - 1990", "Immig. 1991 - 2000", "Immig. 2001 - 2010", "Immig. 2011 - 2013"]
    },
    sydney: {
        Age: ["Total Persons 18-64", "18 - 24 years", "25 - 34 years", "35 - 44 years", "45 - 54 years", "55 - 64 years"],
        Sex: ["Persons", "Female", "Male"],
        Ethnicity: ["Total persons (ANC1P)",  "North-East Asian", "Central Asian", "Southern Asian", "South-East Asian", "Southern and Central Asian, nfd", "North-West European", "Southern and Eastern European", "Peoples of the Americas", "North African and Middle Eastern", "Sub-Saharan African", "New Zealand Peoples",  "Indigenous Australian",  "Rest of Oceanian (incl nfd)", "Remainder of Australian Peoples (incl nfd)", "Supplementary codes/Not stated"],
        ImmigGen: ["Total", "1gen10s", "1gen00s", "1gen90s", "1gen80s", "1gen pre80", "2gen", "3gen"]
    }
}

const properties = {vancouver: [
    {id: 'z_housing', intro: 'to have', property: 'affordable housing', multiplier: -1},
    {id: 'z_income', intro: 'to have', property: 'at least a moderate income', multiplier: -1},
    {id: 'z_education', intro: 'to have', property: 'a university degree'},
    {id: 'z_language', intro: 'to', property: 'speak English at home', multiplier: -1},
    {id: 'z_employed', intro: 'to be', property: 'employed'},
    {id: 'z_owner', intro: 'to', property: 'own a home'}
], auckland: [
    {id: 'Homeown', intro: 'to', property: 'own a home'},
    {id: 'Univ', intro: 'to have', property: 'a university degree'},
    {id: 'Non-English', intro: 'to', property: 'speak English', multiplier: -1},
    {id: 'Low income', intro: 'to have', property: 'a high income', multiplier: -1},
    {id: 'Employed', intro: 'to be', property: 'employed'}
], sydney: [
    {id: 'Over 30% Z', intro: 'to have', property: 'affordable housing', multiplier: -1},
    {id: 'Low inc Z', intro: 'to have', property: 'at least a moderate income', multiplier: -1},
    {id: 'U educ Z', intro: 'to have', property: 'a university degree'},
    {id: 'Non-Eng Z', intro: 'to', property: 'speak English at home', multiplier: -1},
    {id: 'Employed Z', intro: 'to be', property: 'employed'},
    {id: 'Ownership Z', intro: 'to', property: 'own a home'}
]};

const displayTranslation = {vancouver: {
    Age: {99: "an 18-64 year old", 1: "an 18-24 year old", 2: "a 25-34 year old", 3: "a 35-44 year old", 4: "a 45-54 year old", 5: "a 55-64 year old"},
    Immig_coh: {
        99: "a Canadian resident. (total)",
        1: "was born in Canada, with at least one immigrant parent.",
        12: "was born in Canada, as were my parents.", 
        2: "am not a permanent resident.",
        0: "immigrated to Canada.",
        31: "immigrated before 1980.",
        32: "immigrated between 1980 and 2016. ",
        33: "immigrated between 1980 and 1990. ",
        34: "immigrated between 1991 and 2000. ",
        35: "immigrated between 2001 and 2010. ",
        36: "immigrated between 2011 and 2016. "},
    Vis_min: {
        99: "unspecified ethnicity (total)",
        1: "non-visible minority",
        2: "South Asian",
        3: "Chinese",
        4: "Black",
        5: "Filipino",
        6: "Latin American",
        7: "Arab",
        8: "Southeast Asian",
        9: "West Asian",
        10: "Korean",
        11: "Japanese",
        12: "other visible minority",
        13: "multiple minority"},
    Sex: {99: "person", 1: "man", 2: "woman"},
    Immig_cat: {
        99: "by any means. (total)",
        1: "through family sponsorship.",
        2: "as an economic immigrant.",
        3: "as a refugee.",
        4: "as a humanitarian immigrant.",
        5: "for other reasons."}
}, auckland: {
    Age: {
        "Total": "an 18-64 year old",
        "18 Years - 24 Years": "an 18-24 year old",
        "25 Years - 34 Years": "a 25-34 year old",
        "35 Years - 44 Years": "a 35-44 year old",
        "45 Years - 54 Years": "a 45-54 year old",
        "55 Years - 64 Years": "a 55-64 year old",
        "65 Years and Over": "an over 65 year old"},
    Ethnicity: {"Total Stated": "any", "Total Asian": "any Asian", "Southeast Asian": "Southeast Asian", "Pacific Peoples": "Pacific", "Other Ethnicity": "other", "Middle Eastern": "Middle Eastern", "Mäori": "Mäori", "Latin American": "Latin American", "Indian": "Indian", "European": "European", "Chinese": "Chinese", "Asian nfd - Other Asian": "other Asian", "African": "African"},
    Sex: {"Total": "person", "Male": "man", "Female": "woman"},
    Immigration: {"Total": "(Total)", "New Zealand born": "I was born in New Zealand.", "Immig. Pre1980": "I immigrated before 1980.", "Immig. 1980 - 1990": "I immigrated between 1980 and 1990.", "Immig. 1991 - 2000": "I immigrated between 1991 and 2000.", "Immig. 2001 - 2010": "I immigrated between 2001 and 2010.", "Immig. 2011 - 2013": "I immigrated between 2011 and 2013."}
}, sydney: {
    Age: {
        "Total Persons 18-64": "an 18-64 year old",
        "55 - 64 years": "a 55-64 year old",
        "45 - 54 years": "a 45-54 year old",
        "35 - 44 years": "a 45-44 year old",
        "25 - 34 years": "a 25-34 year old",
        "18 - 24 years": "an 18-24 year old"},
    Sex: {
        "Persons": "person",
        "Male": "man",
        "Female": "woman"
    },
    Ethnicity: {
        "Total persons (ANC1P)": "any",
        "North-East Asian": "Northeast Asian",
        "Central Asian": "Central Asian",
        "Southern Asian": "Southern Asian",
        "South-East Asian": "Southeast Asian",
        "Southern and Central Asian, nfd": "Southern and Central Asian",
        "North-West European": "Northwest European",
        "Southern and Eastern European": "Southern and Eastern European",
        "Peoples of the Americas": "North and South American",
        "North African and Middle Eastern": "Middle Eastern",
        "Sub-Saharan African": "Sub-Saharan African",
        "New Zealand Peoples": "New Zealand",
        "Indigenous Australian": "Indigenous Australian",
        "Rest of Oceanian (incl nfd)": "other Oceanian",
        "Remainder of Australian Peoples (incl nfd)": "other Australian",
        "Supplementary codes/Not stated": "unknown"
    },
    ImmigGen: {
        "Total": "(Total)",
        "3gen": "My grandparents immigrated to Australia.",
        "2gen": "My parents immigrated to Australia.",
        "1gen90s": "I immigrated between 1990 and 1999. ",
        "1gen80s": "I immigrated between 1980 and 1989. ",
        "1gen00s": "I immigrated between 2000 and 2009. ",
        "1gen10s": "I immigrated between 2010 and 2018. ",
        "1gen pre80": "I immigrated before 1980."
    }
}};

export default class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        d3.csv('data/individual/' + this.props.city + '.csv').then((data) => {
            this.setState({data});
        });
    }

    shouldComponentUpdate(newProps, newState) {
        if (newProps.city != this.props.city) {
            d3.csv('data/individual/' + newProps.city + '.csv').then((data) => {
                this.setState({data});
            });
        
            return false;
        }

        if (Object.keys(displayTranslation[newProps.city][keyOrder[newProps.city][0]]).indexOf(newProps.filters[0]) < 0) {
            this.updateFilters(defaultFilters[newProps.city]);
            return false;
        }

        if ((newProps.city === 'vancouver') && (["1", "12", "13", "2"].indexOf(newProps.filters[1]) !== -1) && newProps.filters[4] !== "99") {
            let newfilters = newProps.filters;
            newfilters[4] = "99";
            this.updateFilters(newfilters);
            return false;
        }

        return true;
    }

    updateFilters(filters) {
        this.props.update({filters});
    }

    render() {
        if (this.state.data) {
            let toDisplay = this.state.data.filter((d) => {
                let satisfies = true;
                
                for (var i = 0; i < keyOrder[this.props.city].length; i++) {
                    satisfies = satisfies && (this.props.filters[i] === d[keyOrder[this.props.city][i]]);
                }
                return satisfies
            });

            if (toDisplay.length == 0) {
                toDisplay = [{}];
                properties[this.props.city].forEach(p => {
                    toDisplay[0][p.id] = 0;
                });
            }

            let selector;
            if (this.props.city === "auckland") {
                selector = <React.Fragment>
                    {"I am "}
                    <Dropdown
                        selected={this.props.filters[0]}
                        values={displayTranslation[this.props.city].Age}
                        order={whoOrder.auckland.Age}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[0] = v;
                            this.updateFilters(newFilters);}} />
                    <Dropdown
                        selected={this.props.filters[2]}
                        values={displayTranslation[this.props.city].Sex}
                        order={whoOrder.auckland.Sex}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[2] = v;
                            this.updateFilters(newFilters);}} />
                    {" of "}
                    <Dropdown
                        selected={this.props.filters[1]}
                        values={displayTranslation[this.props.city].Ethnicity}
                        order={whoOrder.auckland.Ethnicity}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[1] = v;
                            this.updateFilters(newFilters);}} />
                    {" descent. "}
                    <br />
                    <Dropdown
                        selected={this.props.filters[3]}
                        values={displayTranslation[this.props.city].Immigration}
                        order={whoOrder.auckland.Immigration}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[3] = v;
                            this.updateFilters(newFilters);}} />
                </React.Fragment>
            } else if (this.props.city === "vancouver") {
                selector = <React.Fragment>
                    {"I am "}
                    <Dropdown
                        selected={this.props.filters[0]}
                        values={displayTranslation.vancouver.Age}
                        order={whoOrder.vancouver.Age}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[0] = v;
                            this.updateFilters(newFilters);}} />
                    <Dropdown
                        selected={this.props.filters[2]}
                        values={displayTranslation.vancouver.Vis_min}
                        order={whoOrder.vancouver.Vis_min}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[2] = v;
                            this.updateFilters(newFilters);}} />
                    <Dropdown
                        selected={this.props.filters[3]}
                        values={displayTranslation.vancouver.Sex}
                        order={whoOrder.vancouver.Sex}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[3] = v;
                            this.updateFilters(newFilters);}} />
                    {" and "}
                    <Dropdown
                        selected={this.props.filters[1]}
                        values={displayTranslation.vancouver.Immig_coh}
                        order={whoOrder.vancouver.Immig_coh}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[1] = v;
                            this.updateFilters(newFilters);}} />
                    <br />
                    {["1", "12", "13", "2"].indexOf(this.props.filters[1]) == -1 ? <React.Fragment>
                        {"I was admitted to Canada "}
                        <Dropdown
                            selected={this.props.filters[4]}
                            values={displayTranslation.vancouver.Immig_cat}
                            order={whoOrder.vancouver.Immig_cat}
                            callback={v => {
                                let newFilters = [...this.props.filters];
                                newFilters[4] = v;
                                this.updateFilters(newFilters);}} />
                        </React.Fragment> : []}
                </React.Fragment>
            } else if (this.props.city === 'sydney') {
                selector = <React.Fragment>
                    {"I am "}
                    <Dropdown
                        selected={this.props.filters[1]}
                        values={displayTranslation.sydney.Age}
                        order={whoOrder.sydney.Age}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[1] = v;
                            this.updateFilters(newFilters);
                        }} />
                    <Dropdown
                        selected={this.props.filters[0]}
                        values={displayTranslation.sydney.Sex}
                        order={whoOrder.sydney.Sex}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[0] = v;
                            this.updateFilters(newFilters);
                        }} />
                    {" of "}
                    <Dropdown
                        selected={this.props.filters[2]}
                        values={displayTranslation.sydney.Ethnicity}
                        order={whoOrder.sydney.Ethnicity}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[2] = v;
                            this.updateFilters(newFilters);
                        }} />
                    {" descent. "}
                    <Dropdown
                        selected={this.props.filters[3]}
                        values={displayTranslation.sydney.ImmigGen}
                        order={whoOrder.sydney.ImmigGen}
                        callback={v => {
                            let newFilters = [...this.props.filters];
                            newFilters[3] = v;
                            this.updateFilters(newFilters);
                        }} />
                </React.Fragment>                
            }


        return <div id="dashboard">
            <div className="who">
                {selector}
            </div>
            <div className="what">
                {properties[this.props.city].map((p, i) => {
                    let br = [];
                    if (i % 2) {
                        br = <hr />;
                    }

                    if ((i === properties[this.props.city].length - 1) && ((i%2) == 0)) {
                        br = <div className="dialrow" style={{width: "422px", height: "1px"}}></div>;
                    }

                    return <React.Fragment><Row
                        intro={p.intro}
                        property={p}
                        value={toDisplay[0][p.id]}
                        flip={i % 2}
                        />{br}</React.Fragment> 
                })}
            </div>
            </div>
        } else {
            return <div id="dashboard">
            </div>
        }
    }
}


// WEBPACK FOOTER //
// ./src/Dashboard/Dashboard.jsx